import { createSelector } from 'reselect';

export const getTicketSettings = state => state.ticketsSettings;
